<template>
  <p>
    {{ description }}
  </p>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'PolicyDescription',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    description() {
      const { item } = this;
      const description = get(item, 'description', '');

      return description.substring(0, description.indexOf('.') + 1);
    },
  },
};
</script>
